module.exports = __webpack_public_path__ + "img/case_4.83b7286b.svg";